// This file contains data for the Blox Fruits calculator

export const fruits = [
  {
    id: 'flame',
    name: 'Flame Fruit',
    value: 800000,
    description: 'A logia-type fruit that allows the user to control fire.',
    pvpRating: 8,
    pveRating: 9,
    farmingRating: 7,
    raidingRating: 8
  },
  {
    id: 'ice',
    name: 'Ice Fruit',
    value: 700000,
    description: 'A logia-type fruit that allows the user to control ice.',
    pvpRating: 7,
    pveRating: 8,
    farmingRating: 6,
    raidingRating: 7
  },
  {
    id: 'quake',
    name: 'Quake Fruit',
    value: 1000000,
    description: 'A paramecia-type fruit that allows the user to create shockwaves.',
    pvpRating: 10,
    pveRating: 9,
    farmingRating: 5,
    raidingRating: 9
  },
  {
    id: 'light',
    name: 'Light Fruit',
    value: 650000,
    description: 'A logia-type fruit that allows the user to control light and travel at light speed.',
    pvpRating: 9,
    pveRating: 7,
    farmingRating: 10,
    raidingRating: 7
  },
  {
    id: 'dark',
    name: 'Dark Fruit',
    value: 650000,
    description: 'A logia-type fruit that allows the user to control darkness.',
    pvpRating: 9,
    pveRating: 8,
    farmingRating: 6,
    raidingRating: 8
  },
  {
    id: 'magma',
    name: 'Magma Fruit',
    value: 750000,
    description: 'A logia-type fruit that allows the user to control magma.',
    pvpRating: 8,
    pveRating: 10,
    farmingRating: 8,
    raidingRating: 9
  },
  {
    id: 'buddha',
    name: 'Buddha Fruit',
    value: 525000,
    description: 'A paramecia-type fruit that allows the user to transform into a giant Buddha statue.',
    pvpRating: 6,
    pveRating: 10,
    farmingRating: 9,
    raidingRating: 10
  },
  {
    id: 'venom',
    name: 'Venom Fruit',
    value: 950000,
    description: 'A logia-type fruit that allows the user to control poison.',
    pvpRating: 9,
    pveRating: 9,
    farmingRating: 7,
    raidingRating: 8
  }
];

export const weapons = [
  {
    id: 'saber',
    name: 'Saber',
    damage: 50,
    speed: 7,
    range: 4,
    description: 'A basic sword with balanced stats.'
  },
  {
    id: 'katana',
    name: 'Katana',
    damage: 45,
    speed: 9,
    range: 3,
    description: 'Fast attack speed but shorter range.'
  },
  {
    id: 'pole',
    name: 'Pole (First Form)',
    damage: 60,
    speed: 6,
    range: 8,
    description: 'Long range but slower attack speed.'
  },
  {
    id: 'trident',
    name: 'Trident',
    damage: 65,
    speed: 5,
    range: 6,
    description: 'High damage with good range.'
  },
  {
    id: 'jitte',
    name: 'Jitte',
    damage: 55,
    speed: 8,
    range: 4,
    description: 'Good attack speed with decent damage.'
  },
  {
    id: 'bisento',
    name: 'Bisento',
    damage: 75,
    speed: 4,
    range: 7,
    description: 'Very high damage but slow attack speed.'
  }
];
